import { render, staticRenderFns } from "./LayoutsPreviewModal.vue?vue&type=template&id=4ec47e68&scoped=true"
import script from "./LayoutsPreviewModal.vue?vue&type=script&lang=js"
export * from "./LayoutsPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./LayoutsPreviewModal.vue?vue&type=style&index=0&id=4ec47e68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec47e68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec47e68')) {
      api.createRecord('4ec47e68', component.options)
    } else {
      api.reload('4ec47e68', component.options)
    }
    module.hot.accept("./LayoutsPreviewModal.vue?vue&type=template&id=4ec47e68&scoped=true", function () {
      api.rerender('4ec47e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutsPreviewModal.vue"
export default component.exports